import * as React from 'react';
import {
    Controller,
    Toolbar,
    ActionPointInfo,
    IActionPointInfo,
} from '@tencent/workbench';
import { IndentationFeature } from './indentation-feature';
import {
    TOOLBAR_ITEMS,
    config,
    increaseIndent,
    reduceIndent,
} from './config';
import { Form } from '@tencent/wb-ext-form';
import { FORM_CONFIGS_INDENT } from '@framework/workbench/drawer/ui/text/paragraph/config';

/**
 * 缩进
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    formItems: FORM_CONFIGS_INDENT,
})
export class IndentationController {
    constructor(private readonly feature: IndentationFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    public dropdownContent() {
        return this.feature.showContent(true);
    }

    @Toolbar(config.id, 'onArrowClick')
    public verticalAlignArrowClicked() {
        // 兼容workbench的写法，不能删除
    }

    @Toolbar(increaseIndent.id, 'onClick')
    @Toolbar(reduceIndent.id, 'onClick')
    @Toolbar(config.id, 'onClick')
    public onToolbarClick(@ActionPointInfo() info:  IActionPointInfo) {
        let { name } = info;
        if (config.id === name) {
            name = increaseIndent.id;
        }
        this.feature.callbackByActionType(name, name);
    }

    @Form(increaseIndent.id, 'onClick')
    @Form(reduceIndent.id, 'onClick')
    public onDrawerClick(@ActionPointInfo() info:  IActionPointInfo) {
        let { name } = info;
        if (config.id === name) {
            name = increaseIndent.id;
        }
        this.feature.drawerCallbackByActionType(name, name);
    }
}
